import React, {FC, PropsWithChildren} from 'react';

export const PageTitle: FC<PropsWithChildren> = ({children}) => (
  <div className="flex justify-center items-center">
    <h1 className="text-black align-middle whitespace-normal text-center">{String(children).toUpperCase()}</h1>
  </div>
);
